import React, { useEffect, useState } from "react";
import axios from "axios";
import { APP_TYPE, COLLEGE } from "../../../../utils";
import { ServiceUrl } from "../../../../utils/serviceUrl";
import { Card, Row, Col, Modal } from "react-bootstrap";
import { Spin } from "antd";

const Style3 = () => {
  const [dataList, setDataList] = useState([]);
  const [loader, setLoader] = useState(false);

  // Modal State
  const [showModal, setShowModal] = useState(false);
  const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);

  useEffect(() => {
    loadData();
  }, []);

  const handleShow = (item) => {
    setSelectedAnnouncement(item);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedAnnouncement(null);
  };

  const loadData = () => {
    setLoader(true);
    let url = "";
    if (APP_TYPE === "SAAS") url = "?sadb=" + COLLEGE;
    axios.get(ServiceUrl.ADMISSION.ANNOUNCEMENTS + url).then((res) => {
      if (res["data"].status == "1") {
        setDataList(res["data"].data);
      }
      setLoader(false);
    });
  };

  const renderAnnouncement = (item, isFull) => (
    <div className="admission-card-style3-horizontal mx-3">
      <div className="d-flex align-items-center mb-1">
        <div className="bg-theme text-white px-2 rounded me-2 fs-10 fw-900 border-radius-5">
          NEW
        </div>
        <h6 className="m-0 fw-800 text-dark fs-14 text-truncate">
          {item.title}
        </h6>
      </div>
      <div className="admission-card-style3-horizontal-content mb-2">
        <div
          className="fs-13 text-muted lh-base line-clamp-4"
          dangerouslySetInnerHTML={{ __html: item.content_html }}
        />
      </div>
      <div className="text-end">
        <span
          className="text-primary fs-11 fw-700 cursor-pointer hover-underline"
          onClick={() => handleShow(item)}
        >
          Click here to Read More{" "}
          <i className="fa-solid fa-chevron-right fs-9 ms-1"></i>
        </span>
      </div>
    </div>
  );

  return (
    <div className="text-center text-md-start slide-up-animation pb-2 style-3-container">
      <div className="d-inline-flex align-items-center bg-white bg-opacity-10 border border-white border-opacity-25 rounded-pill px-3 py-1 mb-3 backdrop-blur shadow-sm sliding-pill">
        <span className="badge bg-danger text-white rounded-pill me-2 only-new-sliding pulse-badge">
          IMPORTANT
        </span>
        <span className="text-white fs-13 fw-600 letter-spacing-1 admission-text-fixed">
          Announcements
        </span>
      </div>
      <h1 className="text-white fw-900 display-4 mb-2 text-shadow-sm">
        Stay Informed
      </h1>
      <p className="text-light fs-16 fw-500 opacity-75 max-w-600 mx-auto mx-md-0 mb-4">
        Keep track of the latest admission news and updates.
      </p>

      <Spin spinning={loader}>
        <div className="mt-4 marquee-container-style3">
          <div className="marquee-inner-style3">
            {[...dataList, ...dataList, ...dataList, ...dataList].map(
              (item, index) => (
                <React.Fragment key={index}>
                  {renderAnnouncement(item, false)}
                </React.Fragment>
              ),
            )}
          </div>
        </div>
      </Spin>

      {/* Detail Modal */}
      <Modal show={showModal} onHide={handleClose} centered size="lg">
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="fw-900 text-dark fs-20">
            {selectedAnnouncement?.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-3">
          <div
            className="fs-15 text-dark lh-base announcement-detail-content"
            dangerouslySetInnerHTML={{
              __html: selectedAnnouncement?.content_html,
            }}
          />
        </Modal.Body>
        <Modal.Footer className="border-0">
          <button
            className="btn btn-dark px-4 rounded-pill"
            onClick={handleClose}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Style3;
